export default __webpack_public_path__ + "static/SONY_WDRMODE_0_ALL_AUTO_NIGHT_thumb-d1a2fbc86c5afd58912a401a5d34b500.webp";